import React from "react";

import { EquipmentStepper0, EquipmentStepper1, EquipmentStepper2 } from "../../NewComponents/Equipments/index";

const Equipment = ({ filterSelectedData, setFilterSelectedData, stepperState, setStepperState }) => {
  return (
    <>

      <section id="header-eqipment-container">

        <div className="equipment-block">
          <div className="left-equipment-section">
            {(() => {
              switch (stepperState) {
              case 0:
                return <EquipmentStepper0 stepperState={stepperState} setStepperState={setStepperState} setFilterSelectedData={setFilterSelectedData} filterSelectedData={filterSelectedData} />;
              case 1:
                return <EquipmentStepper1 stepperState={stepperState} setStepperState={setStepperState} setFilterSelectedData={setFilterSelectedData} filterSelectedData={filterSelectedData} />;
              case 2:
                return <EquipmentStepper2 stepperState={stepperState} setStepperState={setStepperState} setFilterSelectedData={setFilterSelectedData} filterSelectedData={filterSelectedData} />;
              default:
                return;
              }
            })()}
          </div>

          <div className="right-equipment-section"></div>
        </div>
      </section>
    </>
  );
};

export default Equipment;
